import { HTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

interface TitleProps extends HTMLAttributes<HTMLDivElement> {
    text: string
}

export function Title({ text, ...rest }: TitleProps) {
    return (
        <div {...rest} className={twMerge("tw-w-full tw-text-4xl tw-font-bold tw-text-neutral-800", rest.className)}>
            {text}
        </div>
    );
}